import { OreButton, OreStack, OreTooltip, SvgArrowLeft } from '@edenredespana/oreneta'
import { useRef } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { CancelPopup, CancelPopupActions } from '@/Contract/ui/atoms/CancelPopup'
import { useBankAccount } from '@/Contract/ui/context'
import { contractTranslation } from '@/Contract/ui/contractTranslation'
import { BankAccountConfirmationForm } from '@/Contract/ui/hooks'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const Step2Actions = (): JSX.Element => {
  const { t } = useTranslation()
  const { previousStep, isSepaDownloaded, acceptSepa } = useBankAccount()
  const { handleSubmit } = useFormContext<BankAccountConfirmationForm>()

  const ref = useRef<CancelPopupActions>(null)

  const cancel = async (): Promise<void> => {
    ref.current?.open()
  }

  const isDownloaded = isSepaDownloaded()

  const signButton = (
    <OreButton
      data-testid="sign"
      category={'primary'}
      onClick={handleSubmit(acceptSepa)}
      disabled={!isDownloaded}
    >
      {t(contractTranslation.changeBankAccount.step2.buttons.next.label)}
    </OreButton>
  )

  return (
    <OreStack space="large" direction="row" placeContent="space-between">
      <OreButton category={'tertiary'} icon={<SvgArrowLeft />} onClick={previousStep}>
        {t(contractTranslation.changeBankAccount.step2.buttons.previous.label)}
      </OreButton>
      <OreStack direction="row" space="small">
        <OreButton category={'secondary'} onClick={cancel}>
          {t(formTranslation.common.buttons.cancel)}
        </OreButton>
        {!isDownloaded ? (
          <OreTooltip
            text={t(contractTranslation.changeBankAccount.step2.buttons.next.tooltip)}
            placement="top"
          >
            {signButton}
          </OreTooltip>
        ) : (
          signButton
        )}
      </OreStack>
      <CancelPopup ref={ref} />
    </OreStack>
  )
}
